import { GET_JOBS } from "../constants/ActionTypes"

const initialState = {
}

const jobs = (state = initialState, action) => {
  switch (action.type) {
    case GET_JOBS:
      return {
        ...state,
        ...action.jobs,
      }
    default:
      return state
  }
}

export default jobs


// WEBPACK FOOTER //
// ./src/reducers/jobs.js